import { createFeatureSelector, createSelector } from '@ngrx/store';
import { featureKey } from '../../store/smrt.reducers';
import { SMRTState } from '../../store/smrt.states';
import { IStartupState } from './state';

export const memberPortalState = createFeatureSelector<SMRTState>(featureKey);
export const getStartup = createSelector(memberPortalState, (state) => state.startupState);

export const getStartup_Form = createSelector(
  getStartup,
  (state: IStartupState) => state.form
);

export const getStartup_Url = createSelector(
  getStartup,
  (state: IStartupState) => state.url
);

export const getStartup_IsLoading = createSelector(
  getStartup,
  (state: IStartupState) => state.isLoading
);

export const getStartup_isUnavailable = createSelector(
  getStartup,
  (state: IStartupState) => state.isUnavailable
);

export const getStartup_isUnavailableMessage = createSelector(
  getStartup,
  (state: IStartupState) => state.isUnavailableMessage
);
